<ng-template #uploadpo let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title"><b>Purchase Order Uploader</b></h4>
		<h6 *ngIf="poReviewReady">File count : ({{files.length}})</h6>
		<button mat-stroked-button class="pomodalbtn position-absolute r-70" (click)="$event.preventDefault();toggleUploadHelp()" (keydown.enter)="$event.preventDefault();">Help</button>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>

	</div>
	<div class="modal-body pomodalbody po-upload-modal-body">
		<ng-container *ngIf="!poHelp">
			<p class="text-muted small mb-2" *ngIf="!poReviewReady">One CSV or Excel file. Choose the sheet if the workbook has several tabs, set <strong>Header row #</strong> if titles are not on row 1, load rows, map columns, then match to inventory.</p>
			<ngx-dropzone
				(change)="onPoDropzoneChange($event)"
				class="dropzone"
				*ngIf="!processing_recs && !poReviewReady"
				[multiple]="false"
				[expandable]="true"
				accept=".csv,.xlsx,.xls,text/csv,text/plain,application/csv,text/x-csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
				[disabled]="processing_recs">
				<ngx-dropzone-label class="dropzone-label">Drop file, or click to upload</ngx-dropzone-label>
				<ngx-dropzone-preview *ngFor="let f of files;" [removable]="true" (removed)="onRemove(f)">
					<ngx-dropzone-label class="overflow-auto ">{{ f.name }}</ngx-dropzone-label>
				</ngx-dropzone-preview>
			</ngx-dropzone>
			<div *ngIf="poShowParseOptions && poActiveFile && !poReviewReady && !processing_recs" class="border rounded p-3 mb-3 bg-light">
				<h6 class="small font-weight-bold text-uppercase text-muted mb-2">Sheet &amp; header</h6>
				<p class="small text-muted mb-2" *ngIf="poUploadReady">Changing the sheet or header row and loading again replaces the column mapping below.</p>
				<div class="row">
					<div class="col-md-6 mb-3" *ngIf="poSheetNames.length">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Worksheet</mat-label>
							<mat-select [(value)]="poSelectedSheetName">
								<mat-option *ngFor="let s of poSheetNames" [value]="s">{{ s }}</mat-option>
							</mat-select>
							<mat-hint>This file has {{ poSheetNames.length }} sheet(s)</mat-hint>
						</mat-form-field>
					</div>
					<div class="col-md-6 mb-3">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Header row #</mat-label>
							<input matInput type="number" min="1" [(ngModel)]="poHeaderRowNumber" name="poHdrRowTires" />
							<mat-hint>Row that contains column titles (e.g. 2 if row 1 is a title only)</mat-hint>
						</mat-form-field>
					</div>
				</div>
				<button mat-raised-button color="primary" type="button" (click)="parsePoSpreadsheetForPoModal()">
					<mat-icon class="align-middle">table_view</mat-icon>
					Load rows &amp; map columns
				</button>
			</div>
			<div class="table-responsive po-upload-map-wrap mb-3" *ngIf="poUploadReady && poUploadedRawData.length && !poReviewReady && !processing_recs">
				<p class="small text-muted mb-2">Map <strong>Internal stock ID</strong> <em>or</em> <strong>Manufacturer part #</strong> (add <strong>Brand</strong> if the sheet splits them). Do not map both ID types. Currency symbols and commas in prices are accepted.</p>
				<div *ngIf="poItemMappingBanner as banner" class="small mb-2" [class.text-warning]="banner.type === 'error'" [class.text-muted]="banner.type === 'hint'">{{ banner.text }}</div>
				<table class="table table-sm table-striped">
					<thead>
						<tr>
							<th *ngFor="let h of poUploadedHeaders" class="small align-top">
								<div class="text-muted text-truncate mb-1" [attr.title]="h">{{ h }}</div>
								<mat-form-field appearance="outline" class="w-100 po-upload-map-field">
									<mat-select [(value)]="poColumnMappings[h]" (selectionChange)="poColumnMappings[h] = $event.value">
										<mat-option *ngFor="let type of poAvailableFieldTypes" [value]="type">{{ poUploadFieldLabel(type) }}</mat-option>
									</mat-select>
								</mat-form-field>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let row of poUploadedRawData; let i = index" [class.table-primary]="i < 3">
							<td *ngFor="let h of poUploadedHeaders">{{ row[h] }}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="table table-responsive text-center" *ngIf="processing_recs && !poReviewReady">
				<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
					<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
				</svg>
			</div>
			<mat-tab-group *ngIf="poReviewReady">
				<mat-tab label="Recognized" *ngIf="poDataSource['good']">
					<table mat-table [dataSource]="poDataSource['good']" class="mat-elevation-z8 demo-table" *ngIf="poReviewReady" class="po-table">
						<ng-container matColumnDef="stockid">
							<th mat-header-cell *matHeaderCellDef> Stock ID </th>
							<td mat-cell *matCellDef="let element"> {{element.stockid}} </td>
						</ng-container>

						<ng-container matColumnDef="vendor">
							<th mat-header-cell *matHeaderCellDef> Recommendation Source </th>
							<td mat-cell *matCellDef="let element" class="text-center "> {{element.vendor}} </td>
						</ng-container>

						<ng-container matColumnDef="description">
							<th mat-header-cell *matHeaderCellDef> Description </th>
							<td mat-cell *matCellDef="let element"> {{element.description}} </td>
						</ng-container>

						<ng-container matColumnDef="manufacturer">
							<th mat-header-cell *matHeaderCellDef> MFG </th>
							<td mat-cell *matCellDef="let element"> {{element.manufacturer}} </td>
						</ng-container>

						<ng-container matColumnDef="line">
							<th mat-header-cell *matHeaderCellDef> Line </th>
							<td mat-cell *matCellDef="let element"> {{element.line}} </td>
						</ng-container>

						<ng-container matColumnDef="min">
							<th mat-header-cell *matHeaderCellDef> Min </th>
							<td mat-cell *matCellDef="let element"> {{element.min}} </td>
						</ng-container>

						<ng-container matColumnDef="max">
							<th mat-header-cell *matHeaderCellDef> Max </th>
							<td mat-cell *matCellDef="let element"> {{element.max}} </td>
						</ng-container>

						<ng-container matColumnDef="qty">
							<th mat-header-cell *matHeaderCellDef> Order Quantity </th>
							<td mat-cell *matCellDef="let element" class="text-center "> {{element.quantity}} </td>
						</ng-container>

						<ng-container matColumnDef="price">
							<th mat-header-cell *matHeaderCellDef> Price </th>
							<td mat-cell *matCellDef="let element"> {{element.price | currency}} </td>
						</ng-container>

						<tr mat-header-row *matHeaderRowDef="poUploadColumns"></tr>
						<tr mat-row *matRowDef="let row; columns: poUploadColumns;"></tr>
					</table>
				</mat-tab>
				<mat-tab label="Unrecognized" *ngIf="poDataSource['bad']">
					<table mat-table [dataSource]="poDataSource['bad']" class="mat-elevation-z8 demo-table" *ngIf="poReviewReady" class="po-table">
						<ng-container matColumnDef="stockid">
							<th mat-header-cell *matHeaderCellDef> Stock ID </th>
							<td mat-cell *matCellDef="let element"> {{element.stockid}} </td>
						</ng-container>

						<ng-container matColumnDef="vendor">
							<th mat-header-cell *matHeaderCellDef> Reccomendation Source </th>
							<td mat-cell *matCellDef="let element" class="text-center "> {{element.vendor}} </td>
						</ng-container>

						<ng-container matColumnDef="description">
							<th mat-header-cell *matHeaderCellDef> Description </th>
							<td mat-cell *matCellDef="let element"> {{element.description}} </td>
						</ng-container>

						<ng-container matColumnDef="manufacturer">
							<th mat-header-cell *matHeaderCellDef> MFG </th>
							<td mat-cell *matCellDef="let element"> {{element.manufacturer}} </td>
						</ng-container>

						<ng-container matColumnDef="line">
							<th mat-header-cell *matHeaderCellDef> Line </th>
							<td mat-cell *matCellDef="let element"> {{element.line}} </td>
						</ng-container>

						<ng-container matColumnDef="min">
							<th mat-header-cell *matHeaderCellDef> Min </th>
							<td mat-cell *matCellDef="let element"> {{element.min}} </td>
						</ng-container>

						<ng-container matColumnDef="max">
							<th mat-header-cell *matHeaderCellDef> Max </th>
							<td mat-cell *matCellDef="let element"> {{element.max}} </td>
						</ng-container>

						<ng-container matColumnDef="qty">
							<th mat-header-cell *matHeaderCellDef> Order Quantity </th>
							<td mat-cell *matCellDef="let element" class="text-center "> {{element.quantity}} </td>
						</ng-container>

						<ng-container matColumnDef="price">
							<th mat-header-cell *matHeaderCellDef> Price </th>
							<td mat-cell *matCellDef="let element"> {{element.price | currency}} </td>
						</ng-container>

						<tr mat-header-row *matHeaderRowDef="poUploadColumns"></tr>
						<tr mat-row *matRowDef="let row; columns: poUploadColumns;"></tr>
					</table>
				</mat-tab>
			</mat-tab-group>
		</ng-container>
		<ng-container *ngIf="poHelp">
			<div class="row">
				<div class="col">
					<h4><b>Columns</b></h4>
					<p class="small">After loading, map <strong>Internal stock ID</strong> <em>or</em> <strong>Manufacturer part #</strong>, plus <strong>Order quantity</strong>. If there is no internal item code column, map <strong>Brand</strong> and <strong>Manufacturer part #</strong>. Optional: price, description, vendor.</p>
					<hr>
					<h4><b>Notes</b></h4>
					<ul style="max-height: 150px;" class="overflow-auto ">
						<li>
							<p>Each line is validated in inventory. Matches appear under Recognized; unknown item values appear under Unrecognized.</p>
						</li>
						<li>
							<p>Only recognized lines are added when you build the PO.</p>
						</li>
						<li>
							<p>One spreadsheet file per upload. Use a workbook tab that contains the PO lines.</p>
						</li>
						<li>
							<p>When price is left blank, the system uses last PO price, or primary supplier price if needed.</p>
						</li>
						<li>
							<p>Lines with order quantity 0 are skipped.</p>
						</li>
						<li>
							<p>Remove the file from the drop zone to start over.</p>
						</li>
					</ul>
				</div>
				<mat-divider vertical="true"></mat-divider>
				<div class="col">
					<h4><b>Row data tips</b></h4>
					<ul>
						<li>Matching mode is determined by your column mapping (internal ID vs manufacturer part ± brand), not a separate toggle.</li>
						<li>Quantities must be numeric. Prices may include currency symbols; commas are stripped.</li>
					</ul>
					<hr>
					<h4>How matching is chosen</h4>
					<ul>
						<li><strong>Internal stock ID</strong> — your system SKU / PLL; sent as-is.</li>
						<li><strong>Manufacturer part #</strong> — resolved to a stockid. With <strong>Brand</strong> mapped, each row needs both; they are combined for lookup.</li>
					</ul>
				</div>
			</div>

		</ng-container>





	</div>
	<div class="modal-footer pomodalfooter po-upload-modal-footer" [ngClass]="upload_error ? 'p-5' : ''">
		<div class="pomodalvendors d-flex flex-wrap w-100 align-items-start mx-0">
			<div>
				<span>Selected Vendor</span>
				<hr class="p-0 m-0">
				<h4><b><span [ngClass]="vendors_detected != false && customer.supplierid != vendors_detected ? 'warning' : ''">{{customer.supplierid}}</span> : {{customer.suppname}}</b></h4>
			</div>
			<div *ngIf="vendors_detected">
				<span>Detected</span>
				<hr class="p-0 m-0">
				<h4><span [ngClass]="customer.supplierid != vendors_detected ? 'warning' : ''">{{vendors_detected}}</span></h4>
			</div>
			<div *ngIf="poReviewReady">
				<span>Recognized</span>
				<hr class="p-0 m-0">
				<h4>Units: {{uploadPodata['units']['good']}} Lines: {{uploadPodata['lines']['good']}} <br></h4>
			</div>
			<div *ngIf="poReviewReady && poDataSource['bad']">
				<span>Unrecognized</span>
				<hr class="p-0 m-0">
				<h4>Units: {{uploadPodata['units']['bad']}} Lines: {{uploadPodata['lines']['bad']}} <br></h4>
			</div>
			<div *ngIf="upload_error" class="error_container">
				<span>Processing Error</span>
				<hr class="p-0 m-0 w-100 ">
				<h4 class='d-flex '>
					<ng-container *ngFor="let file of upload_error">
						<div *ngFor="let err of file | keyvalue" class="mr-5">
							{{err.key}} : <span class="warning" style="font-size: 16px;">{{err.value.message}} &nbsp;</span>
							<br style="height: 1px;">
							<span style="font-size: 12px;">{{err.value.file}}</span>
						</div>
					</ng-container>
				</h4>
			</div>
		</div>

		<div class="po-upload-footer-actions" [class.po-upload-footer-review]="poReviewReady">
			<button mat-stroked-button *ngIf="!poReviewReady" class="pomodalbtn" (click)="$event.preventDefault();uploadPo()" (keydown.enter)="$event.preventDefault();" [disabled]="!poUploadReady || !files.length">Match to inventory</button>
			<button mat-stroked-button *ngIf="poReviewReady" class="pomodalbtn" (click)="$event.preventDefault();resetPoReviewResults()" (keydown.enter)="$event.preventDefault();">Back</button>
			<button mat-stroked-button *ngIf="poReviewReady" class="pomodalbtn" (click)="$event.preventDefault();buildPO()" (keydown.enter)="$event.preventDefault();" [disabled]="!poDataSource['good']">Build PO</button>
		</div>
	</div>
</ng-template>
<ng-template #mmmodal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">{{ promo.itemdesc.stockid }} <span>{{promo.itemdesc.description }}</span></h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">
			<div class="col-md-9">
				<div class="promo-item-description">
					<p class="stock-id">{{ promo.itemdesc.stockid }}</p>
					<p class="description">{{ promo.itemdesc.description }}</p>
				</div>
				<details class="mm-intros-collapse mm-intros-collapse--legacy">
					<summary class="mm-intros-collapse__summary">
						<span class="mm-intros-collapse__label">Included items</span>
						<i class="fa fa-angle-down mm-intros-collapse__chev" aria-hidden="true"></i>
					</summary>
					<div class="mm-intros-collapse__body">
						<ul class="list-group">
							<ng-container *ngFor="let intro of promo.intros">
								<ng-container *ngIf="intro.type === '1' || intro.type === 1">
									<li class="list-group-item item-details-above">
										<div class="item-description">
											<p>{{ intro.stockid }} - {{ intro.description }} ({{ intro.qty }} @ {{ intro.price | currency }})</p>
										</div>
									</li>
								</ng-container>
							</ng-container>
						</ul>
					</div>
				</details>
			</div>
			<div class="col-md-3 text-right">
				<mat-form-field appearance="outline">
					<mat-label>Qty</mat-label>
					<span matPrefix>#</span>
					<input matInput type="number" [(ngModel)]="promo.qty" (input)="setParent($event, promo)" class="text-right">
				</mat-form-field>
				<button class="btn btn-primary mt-2" (click)="addMM(promo)" [disabled]="promo.error">Add To Order</button>
			</div>
		</div>

		<!-- {{ promo.descriptions | json }} <h4>PROMO {{ promo.description }} {{ ispromo.promo.price | currency }} </h4> -->
		<div class="promo-container" *ngIf="promo">
			<h5>Promo Items</h5>
			<div class="row m-0 p-0">
				<ng-container *ngFor="let intro of promo.intros">
					<div class="col-md-{{ 12  / getNumberOfNonType1Intros(promo.intros) }}" *ngIf="intro.type != '1'">
						<div class="promo-intro">
							<h4>{{ intro.name }} {{ intro.description }}</h4>
							<ng-container *ngIf="intro.type === '1'; else typeDefault">
								<div class="intro-details">
									<div class="quantity-info">
										{{ intro.item }} - {{ intro.description }} ({{ intro.qty }} @ {{ intro.price | currency }})
									</div>
								</div>
							</ng-container>
							<ng-template #typeDefault>
								<div class="intro-details" [ngClass]="{'error': intro.error}">
									<div class="quantity-info">
										{{ intro.price }} <span [ngClass]="{'zero-quantity': (updateMMQty(intro) == 0) }">{{ intro.dsptype }} {{ updateMMQty(intro) }} / {{ intro.floor }}</span> {{ intro.price }}
									</div>
								</div>
							</ng-template>
						</div>
						<ng-container *ngFor="let item of intro.items">
							<li class="list-group-item item-details">
								<div class="item-details-row">
									<div class="item-description">
										<p>{{ item.stockid }}</p>
										<p>{{ item.description }}</p>
									</div>
									<div class="item-quantity">
										<button mat-icon-button (click)="decrementmm(item, intro)">
											<mat-icon>remove</mat-icon>
										</button>
										<input matInput type="text" class="quantity-input" value="{{ item.quantity | number }}" (input)="qtyMM($event, item, intro)">
										<button mat-icon-button (click)="incrementmm(item, intro)">
											<mat-icon>add</mat-icon>
										</button>
									</div>
								</div>
							</li>
						</ng-container>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
</ng-template>
<ng-template #itemHistoryRef let-modal>
	<div class="modal-header">
		<h4 class="modal-title">{{ selecteditem.stockid }} <span [innerHTML]="cleanAndFormatHTML(selecteditem.description)"></span></h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<mat-tab-group>
			<mat-tab label="{{ customer.name }} Sales">
				<div class="row mt-3">
					<div class="col-12">

						<div class="row" *ngIf="!itemhistory.length">
							<div class="col-12 text-center">
								<h5>No Sales History</h5>
							</div>
						</div>
						<table class="table table-sm smaller-font" *ngIf="itemhistory.length">
							<tr>
								<th>Date</th>
								<th>Type</th>
								<th>Order#</th>
								<th>Qty</th>
								<th>Price</th>
								<th>Total</th>
							</tr>
							<tr *ngFor="let i of itemhistory">
								<td>{{ i.trandate }}</td>
								<td>{{ i.typename }}</td>
								<td>{{ i.order_ }}</td>
								<td>{{ i.quantity }}</td>
								<td>{{ i.price  | currency}}</td>
								<td>{{ i.price * i.quantity | currency }}</td>
							</tr>
						</table>
					</div>
				</div>
			</mat-tab>
			<mat-tab label="Purchases">
				<!-- (orderloaded)="selectItemLookup($event)" (orderinvoice)="invoiceOrder($event)" -->
				<h4>Open Purchase Orders</h4>
				<app-open-purchase-orders [item]="selecteditem.stockid"></app-open-purchase-orders>
				<mat-divider></mat-divider>
				<h4>Purchase History</h4>
				<table class="table table-sm" *ngIf="itemhistory.purchase">
					<thead>
						<tr>
							<th class="text-left w-20">SUPP</th>
							<th class="text-left w-20">PO</th>
							<th class="text-left w-20">DATE</th>
							<th class="text-center w-20">QTY</th>
							<th class="text-right w-20">COST</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let h of itemhistory.purchase">
							<td class="text-left"> {{h.suppname}}</td>
							<td class="text-left"> {{h.orderno}}</td>
							<td class="text-left"> {{h.orddate}}</td>
							<td class="text-center"> {{h.quantityord}}</td>
							<td class="text-right"> {{h.unitprice | currency}}</td>
						</tr>
					</tbody>
				</table>
			</mat-tab>
			<mat-tab label="Purchase Data">
				<div class="row m-0 p-0 mt-3">
					<ng-container *ngFor="let pdata of selecteditem.purchdata">
						<mat-card class="ml-auto mr-auto col-md-4 cpdata" [ngClass]="selecteditem.selected_po_option == pdata ? 'cpdata-selected': '' " (click)="setItemSelectedPoOption(selecteditem,pdata)">
							<mat-card-header>
								<mat-card-subtitle><span matBadge="{{ pdata.preferred_sort }}" matBadgeSize="small" matBadgeColor="accent"></span></mat-card-subtitle>
								<mat-card-title>{{ pdata.supplierid }} - {{ pdata.suppname }} </mat-card-title>
								<mat-card-title> {{ pdata.price | currency }}</mat-card-title>
							</mat-card-header>
							<mat-card-content>
								<h4>Inventory</h4>
								<ng-container *ngIf="pdata.remote">
									<ul class="entry-list p-0 m-0" *ngFor="let remote of pdata.remote">
										<li>
											<div class="spec-label">{{ remote.feedlabel }}:</div>
											<div class="spec-value">{{ remote.qty }}</div>
										</li>
									</ul>
								</ng-container>
								<ng-container *ngIf="!pdata.remote">
									<ul class="entry-list p-0 m-0">
										<li>
											<div class="spec-label">N/A:</div>
											<div class="spec-value">N/A</div>
										</li>
									</ul>
								</ng-container>
							</mat-card-content>

						</mat-card>
					</ng-container>
				</div>
				<app-purchase-data [item]="selecteditem" (newitemdata)="updateItem($event)"></app-purchase-data>
			</mat-tab>
		</mat-tab-group>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>
<ng-template #purchasedetails let-modal (click)="stopProp($event)">
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Purchase Information</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row" *ngFor="let item of purchase_items">
			<div class="col-12">
				<app-purchase-data [item]="item" (newitemdata)="updateItem($event)"></app-purchase-data>
			</div>
			<div [ngClass]="item.purchdata.length == 1 ? 'col-md-12': 'col-md-6'" *ngFor="let pdata of item.purchdata">
				<div class="card highlight" (click)="setPurchOrderOptions(item.cart_id, pdata)">
					<span matBadge="{{ pdata.preferred_sort }}" matBadgeSize="large" matBadgeColor="accent"></span>
					<div class="card-header text-center">
						<h4 class="card-title text-center">{{ pdata.supplierid }} - {{ pdata.suppname }} {{ pdata.price | currency }}</h4>
					</div>
					<div class="card-body text-center">
						<div class="col-12">
							<h5>{{ pdata.stockid }} {{ pdata.supplierdescription }}</h5>
						</div>
						<div class="col-12 p-0 m-0">
							<ul class="entry-list p-0 m-0" *ngFor="let remote of pdata.remote">
								<li>
									<div class="spec-label">
										
										{{ remote.feedlabel }}:
									</div>
									<div class="spec-value">{{ remote.qty }}</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>
<ng-template #itemdetails let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title"><b>{{ item_details.stockid }}</b><span [innerHTML]="item_details.name"></span> &nbsp;&nbsp;&nbsp;
			<a *ngIf="config.env.package == 'tires' || (config.env.package == 'beauty'  && !issalesman)" [routerLink]="'/inventory/view/'+item_details.stockid"><i class="pointer fa fa-edit"></i></a>
		</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body">
		<div class="row">
			<mat-card class="tire-card " *ngIf="item_details">
				<mat-card-title-group>
					<mat-card-title>
						<h3 [innerHTML]="cleanAndFormatHTML(item_details.descriptions.name)"></h3>
						<section class="section-small" [innerHTML]="cleanAndFormatHTML(item_details.descriptions.description)"></section>
					</mat-card-title>
					<div class="tire-image">
						<div class="tire-image-container" *ngIf="item_details.image_large">
							<img mat-card-lg-image src="{{ item_details.image_large }}" class="img img-responsive large-thumb" lazy>
						</div>
					</div>
				</mat-card-title-group>
				<mat-card-content class="padding-0">
					<mat-tab-group #tabPanel mat-align-tabs="start" color="accent">
						<mat-tab label="Overview">
							<div class="row">
								<div class="col-md-6">
									Features:<br>
									<span [innerHTML]="cleanAndFormatHTML(item_details.descriptions.features)"></span>
								</div>
								<div class="col-md-6">
									Benefits:<br>
									<span [innerHTML]="cleanAndFormatHTML(item_details.descriptions.benefits)"></span>
								</div>
							</div>
						</mat-tab>
						<mat-tab label="Attributes">
							<div class="row">
								<div class="col-md-6">
									<ul class="spec-list" *ngFor="let a of item_details.additional; let i = index">
										<li *ngIf="!(i % 2)">
											<div class="spec-label"> {{ a.label }}</div>
											<div class="spec-value"> {{ a.value }}</div>
										</li>
									</ul>
								</div>
								<div class="col-md-6">
									<ul class="spec-list" *ngFor="let a of item_details.additional; let i = index">
										<li *ngIf="i % 2">
											<div class="spec-label ml-1"> {{ a.label }}</div>
											<div class="spec-value"> {{ a.value }}</div>
										</li>
									</ul>
								</div>
							</div>
						</mat-tab>
						<mat-tab label="Specs">
							<!-- <mat-form-field appearance="standard" *ngIf="!addingattribute" class="text-right">
								<mat-label>Search Attributes</mat-label>
								<input type="text" class="text-right m-0 p-0" matInput (input)="searchAttributes($event.target.value)" />
							</mat-form-field> -->

							<div class="row">
								<div class="col-6">
									<ul class="spec-list" *ngFor="let a of item_details.specs; let i = index">
										<li *ngIf="!(i % 2)">
											<div class="spec-label"> {{ a.label }}</div>
											<div class="spec-value"> {{ a.value }}</div>
										</li>
									</ul>
								</div>
								<div class="col-6">
									<ul class="spec-list" *ngFor="let a of item_details.specs; let i = index">
										<li *ngIf="i % 2">
											<div class="spec-label ml-1"> {{ a.label }}</div>
											<div class="spec-value"> {{ a.value }}</div>
										</li>
									</ul>
								</div>
							</div>
						</mat-tab>
					</mat-tab-group>
				</mat-card-content>
			</mat-card>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>
<ng-template #orderdetailsModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">{{ orderdetails.deliverto }} ( {{ orderdetails.debtorno }}.{{orderdetails.branchcode}} ) </h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body">
		<div class="row">
			<div class="col-12">
				<h4>INVOICE: <b>{{ orderdetails.orderno }}</b><br>
				</h4>
			</div>
		</div>

		<div class="table table-responsive">
			<table class="table table-sm">
				<thead>
					<tr>
						<th class="text-left">ITEM</th>
						<th class="text-left">DESC</th>
						<th class="text-center">QTY</th>
						<th class="text-center">PRICE</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let item of orderdetails.details">
						<td class="text-left"><b>{{ item.stkcode }}</b></td>
						<td>{{ item.itemdesc }}</td>
						<td class="text-center">{{ item.quantity }} </td>

						<td class="text-right">{{ item.unitprice * item.quantity | currency }} </td>
					</tr>
				</tbody>
			</table>
		</div>

	</div>
	<div class="modal-footer">
	</div>
</ng-template>
<ng-container *ngFor="let item of filtered_items; let i = index;">
	<!-- HEADER -->
	<div class="row mt-0 mb-0 pt-0 pb-0 border-top">
		<div class="text-center text-md-left ml-0" [ngClass]="!showfilters ? 'col-md-7': 'col-md-6'">
			<button tabindex="-1" mat-icon-button aria-label="Change Vendor" color="accent" (click)="viewPurchOrderOptions(item)">
				<mat-icon class="smaller-font">edit</mat-icon>
			</button>
			<span class="bold pointer" (click)="openModal(itemdetails, item)">
				{{ item.stockid }} </span> {{ item.mfginfo?.name }}: {{ item.description }} <span class="bold">{{ item?.size }}</span>

			<span *ngFor="let image of item.attribute_images">
				<img src="{{image}}" class="img img-responsive img-fluid p-0 m-0 attribute-image" lazy>
			</span>

		</div>
		<div class="ml-auto mr-0" [ngClass]="!showfilters ? 'col-md-5 ': 'col-md-6'">
			<ul class="list-group list-group-horizontal list-group-flush mt-0 mb-0 pt-0 pb-0 " *ngIf="!salesman && !isdriver">
				<li class="ml-auto list-group-item m-0 pb-0 text-center">QOH<br> {{ item.locqoh }}</li>
				<li class="list-group-item m-0 pb-0 text-center">COMMITED<br> {{ item.qos }}</li>
				<li class="list-group-item m-0 pb-0 text-center">AVAIL<br> {{ item.locqoh - item.qos }}</li>
				<li class="list-group-item m-0 pb-0 text-center pointer">ON PO<br> {{ item.qoo }}</li>
				<li class="list-group-item m-0 pb-0 text-center">EXT
					<br>
					{{ getLineTotal(item) | currency }}
				</li>
			</ul>
		</div>
	</div>
	<!-- END HEAD -->
	<!-- DETAILS -->
	<div @itemSearch class="row mt-0 mb-0 pt-0 pb-0 " [ngClass]="item.specialflag ? 'specialbox' : 'border-top'">
		<div class="col-md-8 m-0 p-0">
			<div class="row m-0 p-0">
				<div tabindex="-1" class="col-12 col-md-auto mt-3 mr-0 pr-0 text-center" *ngIf="item.thumb" (click)="openModal(itemdetails, item)">
					<img src="{{ item.thumb }}" class="img img-responzive p-0 m-0 " lazy *ngIf="item.thumb" />
				</div>
				<div [ngClass]="item.thumb ? 'col-12 col-md-6' : 'col-12 col-md-6'">
					<div class="row m-0 p-0">
						<ng-container *ngFor="let dsp of item.addon_display">
							<ul class="entry-list col-12 col-md-6 p-0 m-0">
								<li>
									<div class="spec-label">{{ dsp.label }}:</div>
									<div class="spec-value">{{ dsp.value }}</div>
								</li>
							</ul>
						</ng-container>
						<ng-container *ngIf="type == '11'">
							<ul class="entry-list col-12 col-md-6 p-0 m-0">
								<li>
									<div class="spec-label">MAX CREDIT</div>
									<div class="spec-value"><b>{{item.max_credit}}</b></div>
								</li>
							</ul>
						</ng-container>
					</div>
				</div>
				<div class="col-md-3 p-0 m-0" *ngIf="!isdriver">
					<ul class="entry-list col-12 p-0 m-0">
						<li class="text-center">
							<div class="ml-auto mr-auto spec-header">AVAIL</div>
						</li>
						<ng-container *ngIf="type=='11' && item.lastpurchase.date_purchased != null">
							<li>
								<div class="spec-label">Last Purchase</div>
								<div class="spec-value">{{item.lastpurchase.date_purchased}}&nbsp;&nbsp;#<span (click)="loadOrder(item.lastpurchase.orderno)" class="link">{{item.lastpurchase.orderno}}</span></div>
							</li>
						</ng-container>
						<li *ngFor="let w of item.qoh">
							<div class="spec-label">{{ w.locationname }}</div>
							<div class="spec-value">{{ w.quantity - item.qos }}</div>
						</li>
						<li *ngFor="let r of item.remote_inventory">
							<div class="spec-label">
								<ng-container *ngIf="r.combined">
									<button type="button" class="combined-indicator">{{r.combined.current['cutoffhour']}}<mat-icon>schedule</mat-icon></button>
								</ng-container>
								{{ r.feedlabel }}
							</div>
							<div class="spec-value">{{ r.qty }}</div>
						</li>
					</ul>
				</div>
				<ng-container *ngIf="type=='21'">
					<div class="col-md-2">
						<ul class="entry-list col-12 p-0 m-0">
							<li>
								<div class="spec-label">Min O Qty:</div>
								<div class="spec-value"> {{ item.minorderqty }}</div>
							</li>
							<li>
								<div class="spec-label">Max O Qty:</div>
								<div class="spec-value">{{ item.maxorderqty }}</div>
							</li>
							<li>
								<div class="spec-label">Min/MAX:</div>
								<div class="spec-value"> {{ item.minmax.minimum }}/{{ item.minmax.maximum}}</div>
							</li>
						</ul>
					</div>
				</ng-container>
			</div>
		</div>
		<div class="col-md-4 m-0 p-0 text-left">
			<div class="row m-0 p-0">
				<div class="col-12 col-md-7 col-lg-3 ml-auto mr-auto text-center m-0 p-0 ml-md-1 pl-md-1 pr-md-1 mr-md-1 text-md-right form-inputs">
					<mat-form-field appearance="standard" class="" [ngClass]="isdriver ? 'd-none': ''">
						<mat-label *ngIf="!item.specialflag">
							<span *ngIf="type == '21'">Cost</span>
							<span *ngIf="type != '21'"> Sell Price</span>
						</mat-label>
						<mat-label *ngIf="item.specialflag">
							Special Sell Price
						</mat-label>
						<span matPrefix>
							<button tabindex="-1" mat-icon-button aria-label="Change Vendor" color="accent" (click)="viewitemOrderHistory(item)">
								<mat-icon class="smaller-font">visibility</mat-icon>
							</button>
						</span>
						<span matPrefix>$</span>
						<input matInput tabindex="-1" (input)="updateSearchPrice($event, item )" [value]="item.price" class="text-right">

						<mat-hint *ngIf="item.hasdiscount" class="text-danger bolder text-right">
							{{ (item.price - (customer.discount * item.price)) | currency }} @ {{(customer.discountdsp)}}
						</mat-hint>
						<mat-hint *ngIf="item.fetvalue && item.fetvalue != '0.00'" class="text-danger bolder text-right">
							FET: {{ item.fetvalue | currency }}
						</mat-hint>
					</mat-form-field>
				</div>
				<div class="col-12 col-md-7 col-lg-5 m-0 p-0 ml-1 pl-1 pr-1 mr-1 text-right form-inputs">
					<div class="row p-0 m-0">
						<div class="col-2 mt-3 ml-0 mr-0 ml-auto">
							<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-white btn-fab btn-round btn-sm mr-md-2" (click)="decrement(item)">
								<small><i class="material-icons">remove</i></small>
							</button>
						</div>
						<div class="col-6 m-0 ">
							
							<mat-form-field appearance="standard">
								<mat-label>Qty</mat-label>
								<span matPrefix>#</span>
								<input matInput tabindex="{{ i + 2 }}" type="number" (keydown.enter)="addToOrder(item)" value="{{ item.quantity }}" autofocus (input)="updateSearchQuantity($event, item )" class="text-right">
							</mat-form-field>
						</div>
						<div class="col-2 mt-3 ml-0 mr-0 mr-auto ">
							<button tabindex="-1" mat-stroked-button class="btn btn-just-icon btn-white btn-fab btn-round btn-sm mr-md-2" (click)="increment(item)">
								<small>
									<i class="material-icons">add</i></small>
							</button>
						</div>
					</div>
				</div>
				<div class="col-md-1 m-0 p-0 ml-1 pl-1 pr-1 mr-1 mb-3 text-center text-md-right mt-3">

					<button tabindex="-1" mat-stroked-button (color)="'accent'" class="btn btn-just-icon btn-success btn-fab btn-round btn-sm mr-md-2" (click)="addToOrder(item)" *ngIf="!item.ispromo && screenWidth > 751">
						<small><i class="material-icons">add_box</i></small>
					</button>

					<button tabindex="-1" mat-stroked-button (color)="'accent'" class="btn btn-success btn-sm mr-md-2" (click)="addToOrder(item)" *ngIf="!item.ispromo && screenWidth <= 751">
						ADD
					</button>

					<ng-container *ngIf="item.ispromo">
						<button tabindex="-1" mat-stroked-button (color)="'accent'" class="btn btn-just-icon btn-success btn-fab btn-round btn-sm mr-md-2 linetotal_button " (click)="triggerMm(item)" *ngIf="item.ispromo.requiresconfig">
							<small><i class="material-icons">settings</i></small>
						</button>

						<button tabindex="-1" mat-stroked-button (color)="'accent'" class="btn btn-just-icon btn-success btn-fab btn-round btn-sm mr-md-2 linetotal_button " (click)="addPromo(item)" *ngIf="!item.ispromo.requiresconfig">
							<small><i class="material-icons">add_box</i></small>
						</button>

					</ng-container>
				</div>
			</div>
		</div>
	</div>
</ng-container>
